;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    error: { type: String, default: null },
    otpMethod: { type: String, default: "phone" },
    maskedOtpRecipient: { type: String, required: true },
    csrfToken: { type: String, required: true },
    showTimer: { type: Boolean, default: false },
    timerSeconds: { type: Number, default: 120 }
  },
  data: function data() {
    return {
      otpValue: "",
      submitting: false,
      countdown: this.timerSeconds,
      timer: null
    };
  },

  computed: {
    countdownMinutes: function countdownMinutes() {
      return String(Math.floor(this.countdown / 60)).padStart(2, "0");
    },
    countdownSeconds: function countdownSeconds() {
      return String(this.countdown % 60).padStart(2, "0");
    }
  },
  methods: {
    handleInput: function handleInput(event) {
      this.otpValue = event.target.value.toUpperCase();
    },
    handleSubmit: function handleSubmit() {
      if (this.submitting) return;
      console.log(this.otpValue, "Otp value");
      this.submitting = true;
      this.$emit("verify-otp", this.otpValue.toUpperCase());
    },
    startTimer: function startTimer() {
      var self = this;
      self.countdown = self.timerSeconds;
      self.stopTimer();
      self.$emit("timer-start");
      self.timer = setInterval(function () {
        if (self.countdown > 0) {
          self.countdown--;
        } else {
          self.stopTimer();
          self.$emit("timer-expire");
        }
      }, 1000);
    },
    stopTimer: function stopTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }
  },
  watch: {
    error: function error(val) {
      if (val) this.submitting = false;
    },
    showTimer: function showTimer(val) {
      if (val) this.startTimer();
    },
    timerSeconds: function timerSeconds() {
      this.startTimer();
    }
  },
  mounted: function mounted() {
    this.startTimer();
  },
  beforeDestroy: function beforeDestroy() {
    this.stopTimer();
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ac-page"},[(_vm.error)?_c('div',{staticStyle:{"background":"#fee2e2","border":"1px solid #fca5a5","border-radius":"8px","padding":"10px 14px","margin-bottom":"16px","font-size":"14px","color":"#dc2626"}},[_vm._v("\n    "+_vm._s(_vm.error)+"\n  ")]):_vm._e(),_vm._v(" "),_c('form',{staticStyle:{"display":"flex","flex-direction":"column","justify-content":"space-between","height":"265px"},on:{"submit":function($event){$event.preventDefault();return _vm.handleSubmit.apply(null, arguments)}}},[_c('div',[_vm._m(0),_vm._v(" "),_c('p',{staticStyle:{"font-size":"14px","font-weight":"500","color":"#475467","line-height":"24px","margin":"0 0 61px"}},[_vm._v("\n        We have sent an OTP to your\n        "+_vm._s(_vm.otpMethod === "email" ? "email address" : "phone number")+"\n        ending with "),_c('strong',[_vm._v(_vm._s(_vm.otpMethod === "email" ? _vm.maskedOtpRecipient : "+" + _vm.maskedOtpRecipient))])]),_vm._v(" "),_c('div',[_c('label',{staticClass:"ac-label",attrs:{"for":"otp"}},[_vm._v("Enter OTP")]),_vm._v(" "),_c('input',{staticClass:"ac-input",staticStyle:{"border-radius":"6px","text-transform":"uppercase"},attrs:{"type":"text","id":"otp","name":"otp","placeholder":"••••••••","autocomplete":"one-time-code","maxlength":"6","autofocus":"","autocapitalize":"characters"},domProps:{"value":_vm.otpValue},on:{"input":_vm.handleInput}})]),_vm._v(" "),_c('div',{staticStyle:{"font-size":"13px","color":"#667085","min-height":"20px"}},[(_vm.countdown > 0)?[_vm._v("\n          Resend OTP in\n          "),_c('span',{staticStyle:{"font-weight":"600","color":"#344054"}},[_vm._v(_vm._s(_vm.countdownMinutes)+":"+_vm._s(_vm.countdownSeconds))])]:_c('a',{staticStyle:{"color":"#2c7be5","font-weight":"600","text-decoration":"none"},attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.$emit('resend-otp')}}},[_vm._v("Resend OTP")])],2)]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","justify-content":"flex-end"}},[_c('button',{staticClass:"ac-btn-primary",attrs:{"type":"submit","disabled":_vm.submitting}},[_vm._v("\n        "+_vm._s(_vm.submitting ? "Processing..." : "Proceed")+"\n      ")])])])])}
__vue__options__.staticRenderFns = [function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin-bottom":"6px"}},[_c('p',{staticClass:"ac-login-title"},[_vm._v("OTP Verifications")])])}]
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-51cbf9a8", __vue__options__)
  } else {
    hotAPI.reload("data-v-51cbf9a8", __vue__options__)
  }
})()}